var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 500C111.925 500 0 388.075 0 250C0 111.925 111.925 0 250 0C388.075 0 500 111.925 500 250C499.85 388 388 499.85 250 500ZM249.6 450H250C303.026 449.947 353.86 428.839 391.327 391.315C428.794 353.792 449.826 302.926 449.8 249.9C449.773 196.874 428.69 146.029 391.186 108.543C353.682 71.0577 302.826 50.0001 249.8 50.0001C196.774 50.0001 145.918 71.0577 108.414 108.543C70.9096 146.029 49.8265 196.874 49.8 249.9C49.7735 302.926 70.8057 353.792 108.273 391.315C145.74 428.839 196.574 449.947 249.6 450V450ZM200 375L100 275L135.25 239.75L200 304.25L364.75 139.5L400 175L200 375Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f3c5ce2055cc99def8d3a026636dfc34.svg";
export { ForwardRef as ReactComponent };